module.exports = __webpack_public_path__ + "static/media/2021-02-09-01.299c3421.jpg";